import { render, staticRenderFns } from "./FIBRadio.vue?vue&type=template&id=6170cd5c&scoped=true&"
import script from "./FIBRadio.vue?vue&type=script&lang=js&"
export * from "./FIBRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170cd5c",
  null
  
)

export default component.exports
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QRadio});
